import { render } from "./PredictAlertPopup.vue?vue&type=template&id=6c4cc710&scoped=true&ts=true"
import script from "./PredictAlertPopup.vue?vue&type=script&lang=ts"
export * from "./PredictAlertPopup.vue?vue&type=script&lang=ts"

import "./PredictAlertPopup.vue?vue&type=style&index=0&id=6c4cc710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4cc710"]])

export default __exports__